import { scroll } from './scroll'

const navMenuBtn = document.querySelector('.right-menu-btn')
const navMenu = document.querySelector('#mobile-menu')
const navWrapper = document.querySelector('.nav-wrapper')

if (navMenuBtn && navMenu) {
	const openNavMenu = () => {
		navMenuBtn.setAttribute('aria-expanded', 'true')
		navMenu.classList.add('open')
		navWrapper?.classList.add('open')

		navMenuBtn.textContent = 'Close ✕'
	}

	const closeNavMenu = () => {
		navMenuBtn.setAttribute('aria-expanded', 'false')
		navMenu.classList.remove('open')
		navWrapper?.classList.remove('open')

		navMenuBtn.textContent = 'Menu ☰'
	}

	navMenuBtn.addEventListener('click', () => {
		if (navMenu.classList.contains('open')) {
			closeNavMenu()
		} else {
			openNavMenu()
		}
	})
}

document.addEventListener('DOMContentLoaded', () => {
	const hero = document.querySelector('.hero')

	if (scroll) {
		// Sticky pop-down navigation
		scroll?.on('scroll', e => {
			// This is necessary to prevent the navigation from collapsing when mobile Safari users get the "snapback" scroll behavior when they scroll to the top of the page
			let heroIsInView = hero?.classList.contains('is-inview')

			if (e.direction == 'down' && !heroIsInView) {
				navWrapper?.classList.add('collapse')
			} else {
				navWrapper?.classList.remove('collapse')
			}

			if (e.scroll.y <= 10) {
				navWrapper?.classList.remove('background')
			} else {
				navWrapper?.classList.add('background')
			}
		})
	} else {
		let lastScrollTop = window.scrollY
		window.addEventListener('scroll', e => {
			if (window.scrollY > lastScrollTop) {
				navWrapper?.classList.add('collapse')
			} else {
				navWrapper?.classList.remove('collapse')
			}
			lastScrollTop = window.scrollY <= 0 ? 0 : window.scrollY

			if (window.scrollY <= 10) {
				navWrapper?.classList.remove('background')
			} else {
				navWrapper?.classList.add('background')
			}
		})
	}
})
